import tinycolor from 'tinycolor2'

export function generateScale(color, prefix = 'P') {
  const scale = {}

  const opacities = [0.1, 0.2, 0.7, 0.75]

  // Add opaque colors first.
  let indicator = 0

  opacities.forEach(opacity => {
    indicator += 10
    const opaqueColor = tinycolor
      .mix(color, 'white', opacity * 100)
      .toHexString()

    scale[`${prefix}${indicator}`] = opaqueColor
  })

  indicator += 10
  scale[`${prefix}${indicator}`] = color

  opacities.forEach(opacity => {
    indicator += 10
    const opaqueColor = tinycolor
      .mix(color, 'black', opacity * 100)
      .toHexString()

    scale[`${prefix}${indicator}`] = opaqueColor
  })

  // Add opacity colors second.
  opacities.forEach((opacity, index) => {
    const opacityColor = tinycolor(color)
      .setAlpha(opacity)
      .toString()

    scale[`${prefix}O${index + 1}`] = opacityColor
  })

  return scale
}

export function createColorScales(scales) {
  // Delete colors for which the color is null or undefined.
  Object.keys(scales).forEach(key => {
    if (key !== 'primary' && key !== 'neutral') {
      if (scales[key] === null || scales[key] === undefined) {
        delete scales[key]
      }
    }
  })

  Object.keys(scales).forEach(key => {
    if (Object.prototype.hasOwnProperty.call(scales, key)) {
      scales[key] = generateScale(scales[key], key[0].toUpperCase())
    }
  })

  return scales
}

export function createColorPalette(conf) {
  const scales = createColorScales(conf)
  const palette = {}

  Object.keys(scales).forEach(key => {
    if (Object.prototype.hasOwnProperty.call(scales, key)) {
      palette[key] = {
        lightest: scales[key][`${key[0].toUpperCase()}40`], // 5% white
        lightmore: scales[key][`${key[0].toUpperCase()}30`], // 15% white
        lighter: scales[key][`${key[0].toUpperCase()}20`], // 70% white
        light: scales[key][`${key[0].toUpperCase()}10`], // 75% white
        base: scales[key][`${key[0].toUpperCase()}50`],
        dark: scales[key][`${key[0].toUpperCase()}60`], // 5% dark
        darker: scales[key][`${key[0].toUpperCase()}70`], // 15% dark
        darkermore: scales[key][`${key[0].toUpperCase()}80`], // 70% dark
        darkest: scales[key][`${key[0].toUpperCase()}90`], // 75% dark
      }
    }
  })

  return palette
}
